import { isLocal } from '../localId/localId';
import {
  ADD_LOCAL_EMPLOYEE,
  API_CREATE_EMPLOYEE,
  API_LOAD_EMPLOYEES,
  API_REMOVE_EMPLOYEE,
  API_UPDATE_EMPLOYEE,
  REMOVE_LOCAL_EMPLOYEE,
} from './employees.reducer';

export const load = () => ({ resourceAction: API_LOAD_EMPLOYEES });
export const save = resource =>
  ((isLocal(resource.id))
    ? { resourceAction: API_CREATE_EMPLOYEE, resource }
    : { resourceAction: API_UPDATE_EMPLOYEE, resource });
export const add = () => ({ type: ADD_LOCAL_EMPLOYEE });
export const remove = id => ((isLocal(id)) ? {
  type: REMOVE_LOCAL_EMPLOYEE,
  id,
} : { resourceAction: API_REMOVE_EMPLOYEE, id });



// WEBPACK FOOTER //
// ./src/reducers/employees/employees.actions.js